import React from "react";

export default function LoadingOverlay({
  active,
  title = "Loading",
  message = "Please wait a moment.",
}) {
  if (!active) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-[#050811]/78 px-5 backdrop-blur-md">
      <div className="w-full max-w-sm rounded-[32px] border border-white/10 bg-[#0b1020]/96 p-6 text-white shadow-[0_28px_90px_rgba(0,0,0,0.48)]">
        <div className="flex items-center gap-4">
          <div className="relative flex h-14 w-14 items-center justify-center">
            <div className="absolute inset-0 rounded-full border border-[#8f1622]/30" />
            <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-[#8f1622] border-r-[#d63c4f] animate-spin" />
            <div className="h-2.5 w-2.5 rounded-full bg-[#d63c4f] shadow-[0_0_22px_rgba(214,60,79,0.7)]" />
          </div>

          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.24em] text-white/40">
              Barswiper
            </p>
            <h2 className="mt-1 text-xl font-bold">{title}</h2>
          </div>
        </div>

        <p className="mt-5 text-sm leading-6 text-white/68">{message}</p>

        <div className="mt-5 h-1.5 overflow-hidden rounded-full bg-white/8">
          <div className="h-full w-1/2 animate-pulse rounded-full bg-gradient-to-r from-[#4a0d14] via-[#8f1622] to-[#d63c4f]" />
        </div>
      </div>
    </div>
  );
}
